<style>
.telemetry-container {
  border-radius: 20px;
}

.windowtimecontainer {
  overflow-y: scroll;
  margin-left: 5.5rem;
  margin-top: 1rem;
  position: absolute;
  z-index: 1;
}
.windowtimecontainermobile {
  overflow-y: scroll;
  z-index: 1;
  margin-left: 1.5rem;
}
</style>

<template>
  <v-container
    fill-height
    fluid
    style="position:absolute;left:0;top:0;bottom:0;right:0;padding:0;overflow-y:scroll;"
  >
    <v-btn
      v-on:click="drawer = !drawer"
      absolute
      bottom
      fab
      style="z-index:3;bottom:1rem;left:1rem"
      dark
      color="#39a9dc"
      ><v-icon>menu</v-icon></v-btn
    >
    <v-layout row wrap>
      <v-navigation-drawer
        absolute
        v-model="drawer"
        :temporary="
          $vuetify.breakpoint.sm | $vuetify.breakpoint.xs ? true : false
        "
        :style="'width: 30rem;padding:1rem;left:' + (!drawer ? '-30rem' : '')"
      >
        <v-btn
          v-on:click="drawer = !drawer"
          top
          right
          absolute
          style="z-index: 3; top: 0.5rem;"
          dark
          flat
          icon
          color="#39a9dc"
          ><v-icon>menu</v-icon></v-btn
        >
        <div style="text-align:left; margin:0.5rem;margin-bottom:0.5rem">
          <div class="headline">Filters</div>
          <div class="body-1">
            Select devices and window time from here to retrieve related
            telemetry data.
          </div>
        </div>
        <v-form ref="form" v-model="validForm" lazy-validation>
          <v-layout
            row
            wrap
            align-center
            style="
                            padding-left:1rem;
                            padding-right:1rem;
                            margin-bottom:1rem"
          >
            <v-flex xs12 sm12 md12>
              <v-combobox
                color="#39a9dc"
                prepend-icon="memory"
                v-model="selectedDevices"
                label="Select devices"
                :items="devices"
                item-value="id"
                item-text="label"
                multiple
                chips
                return-object
                :rules="selectedDeviceRules"
                required
              >
                <template v-slot:selection="data">
                  <v-chip
                    :key="JSON.stringify(data.item)"
                    :selected="data.selected"
                    :disabled="data.disabled"
                    class="v-chip--select-multi font-weight-bold"
                    @input="data.parent.selectItem(data.item)"
                    color="#FFD300"
                  >
                    <v-avatar>
                      <v-icon color="#39a9dc" dark>memory</v-icon>
                    </v-avatar>
                    {{ data.item.label }}
                  </v-chip>
                </template>
              </v-combobox>
            </v-flex>
            <v-flex xs12 sm12 align-center>
              <v-combobox
                color="#39a9dc"
                prepend-icon="equalizer"
                :items="currentMeasuresAvailable"
                item-value="id"
                item-text="label"
                label="Select measure"
                v-model="selectedMeasure"
                return-object
              ></v-combobox>
            </v-flex>
            <v-flex xs12 sm12 align-center>
              <v-select
                color="#39a9dc"
                :disabled="selectedDevices.length == 0"
                prepend-icon="date_range"
                v-model="selectedWindowTime"
                label="Select window time"
                :items="windowTimes"
                item-value="id"
                item-text="label"
                return-object
                required
                :rules="windowTimeRules"
              ></v-select>

              <v-chip
                v-if="selectedStartTime.timeObj"
                v-on:click="openDataPicker = true"
                color="#002052"
                dark
                style="
                                    float:left;
                                    margin-top:0.5rem"
              >
                <v-avatar
                  ><v-icon color="green" dark>access_time</v-icon></v-avatar
                >
                {{
                  selectedStartTime.timeObj
                    ? selectedStartTime.timeObj.toLocaleTimeString() +
                      " - " +
                      selectedStartTime.timeObj.toLocaleDateString()
                    : ""
                }}
              </v-chip>
              <v-chip
                v-if="selectedEndTime.timeObj"
                v-on:click="openDataPicker = true"
                color="#002052"
                dark
                style="
                                    float:left;
                                    margin-top:0.5rem;;margin-bottom:1rem
                                "
              >
                <v-avatar
                  ><v-icon color="red" dark>access_time</v-icon></v-avatar
                >
                {{
                  selectedEndTime.timeObj
                    ? selectedEndTime.timeObj.toLocaleTimeString() +
                      " - " +
                      selectedEndTime.timeObj.toLocaleDateString()
                    : ""
                }}
              </v-chip>

              <v-btn
                outline
                color="#39a9dc"
                style="width:100%;margin-left:0rem"
                v-on:click="submit"
              >
                <v-icon>play_arrow</v-icon>
                Submit
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-navigation-drawer>

      <v-flex
        xs12
        :style="
          'height:100%;margin-left:' +
            (!($vuetify.breakpoint.sm | $vuetify.breakpoint.xs) && drawer
              ? '30rem'
              : '0')
        "
      >
        <v-container fill-height fluid style="padding:0;margin:0;">
          <v-dialog
            ref="dialog"
            v-model="openDataPicker"
            persistent
            lazy
            full-width
            class="white"
            width="869px"
            style="background-color:white"
          >
            <div class="white">
              <v-time-picker
                color="#39a9dc"
                v-model="timeHourStart"
                format="24hr"
                style="padding:1rem;;padding-bottom:1.85rem"
                width="17.5rem"
                :disabled="!selectedStartTime.timeObj"
              ></v-time-picker>
              <v-date-picker
                color="#39a9dc"
                ref="picker"
                multiple
                v-model="selectedComplexTime"
                min="1950-01-01"
                style=";padding:1rem;padding-bottom:0"
              >
              </v-date-picker>
              <v-time-picker
                color="#39a9dc"
                v-model="timeHourEnd"
                format="24hr"
                style="padding:1rem;padding-bottom:1.85rem"
                width="17.5rem"
                height="15.5rem"
                :disabled="!selectedEndTime.timeObj"
              ></v-time-picker>

              <v-btn flat color="#002052" @click="openDataPicker = false"
                ><v-icon small style="margin-right:0.5rem">close</v-icon
                >Cancel</v-btn
              >
              <v-btn color="#FFD300" v-on:click="submit"
                ><v-icon small style="margin-right:0.5rem">send</v-icon
                >OK</v-btn
              >
            </div>
          </v-dialog>

          <v-layout white style="width:100%;;height:100%" fill-height row wrap>
            <v-flex
              xs12
              sm12
              md9
              style="position:relative;text-align:left;padding:0.5rem;padding-left:0;height:100%;overflow-y:scroll"
            >
              <v-expand-transition
                v-if="
                  telemetryChartModel.datasets
                    ? telemetryChartModel.datasets.length == 0
                    : true
                "
              >
                <div
                  class="d-flex transition-fast-in-fast-out grey lighten-4 v-card--reveal grey--text text-sm-center headline"
                  style="height: 100%;width:100%;opacity:0.5;;position:absolute"
                >
                  <p
                    style=" top: 50%;;position:absolute;width:100%"
                    class=" text-sm-center "
                  >
                    <v-icon>bar_chart</v-icon> No telemetry data available
                  </p>
                </div>
              </v-expand-transition>
              <div style="text-align:left; margin:0.5rem;margin-bottom:0.5rem">
                <div class="headline">Telemetry chart</div>
                <div class="body-1">
                  See here telemetry data sent by selected devices.
                </div>
                <div
                  v-if="selectedMeasure"
                  style="padding-top:1rem"
                  class="body-1"
                >
                  Selected metric:
                  <v-chip
                    class="font-weight-bold"
                    color="#FFD300"
                    style="padding:0.3rem"
                  >
                    <v-avatar>
                      <img
                        :src="
                          '/assets/telemetry/' + selectedMeasure.id + '.png'
                        "
                        onerror="this.style.display='none'"
                      />
                    </v-avatar>
                    {{ selectedMeasure.label }}
                  </v-chip>
                </div>
              </div>
              <div style="width:100%;top:9rem;position:absolute;">
                <chart-new
                  :series="telemetryChartModel.datasets || []"
                ></chart-new>
              </div>
            </v-flex>

            <v-flex
              xs12
              sm12
              md3
              style="position:relative;text-align:left;padding:0.5rem;padding-left:0;overflow-y:scroll;max-height:100%"
            >
              <v-expand-transition v-if="eventsListModel.length === 0">
                <div
                  class="d-flex transition-fast-in-fast-out grey lighten-4 v-card--reveal grey--text text-sm-center headline"
                  style="height: 100%;width:100%;opacity:0.5;;position:absolute"
                >
                  <p
                    style=" top: 50%;;position:absolute;width:100%"
                    class=" text-sm-center "
                  >
                    <v-icon>flash_on</v-icon> No events available
                  </p>
                </div>
              </v-expand-transition>
              <div
                style="text-align:left; margin:0.5rem;margin-bottom:0.5rem;overflow-y:hidden"
              >
                <div class="headline">
                  Events
                  {{
                    eventsListModel.length > 0
                      ? "(" + eventsListModel.length + ")"
                      : ""
                  }}
                </div>
                <div class="body-1">
                  See here events list sent by selected devices.
                </div>
              </div>
              <v-list two-line style="">
                <template v-for="(item, index) in eventsListModel">
                  <v-list-tile :key="index" avatar>
                    <v-tooltip :key="index" bottom>
                      <template v-slot:activator="{on}">
                        <v-list-tile-avatar>
                          <v-icon
                            v-if="item.color !== undefined"
                            :class="item.color"
                            >flash_on</v-icon
                          >
                          <v-icon v-else>flash_on</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-html="
                              item.label +
                                '<span class=\'caption\'>( ' +
                                item.id +
                                ' )</span>'
                            "
                          ></v-list-tile-title>
                          <v-list-tile-sub-title
                            v-html="
                              (item.measure
                                ? item.measure.charAt(0).toUpperCase() +
                                  item.measure.slice(1)
                                : '') +
                                (item.message ? ' - ' + item.message : '')
                            "
                          ></v-list-tile-sub-title>
                          <v-list-tile-action-text
                            v-on="on"
                            v-html="
                              item.timestamp.toLocaleDateString() +
                                ' - ' +
                                item.timestamp.toLocaleTimeString()
                            "
                          ></v-list-tile-action-text>
                        </v-list-tile-content>
                      </template>
                      <span>{{
                        (item.measure
                          ? item.measure.charAt(0).toUpperCase() +
                            item.measure.slice(1)
                          : "") + (item.message ? " - " + item.message : "")
                      }}</span>
                    </v-tooltip>
                  </v-list-tile>

                  <v-divider
                    v-if="index + 1 < eventsListModel.length"
                    :key="index + '_event'"
                    :inset="false"
                  ></v-divider>
                </template>
              </v-list>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <v-snackbar
        :timeout="0"
        :value="telemetryRealtime"
        :bottom="true"
        :right="true"
      >
        <v-progress-circular
          width="1.7"
          style="width:1.2rem;"
          indeterminate
          color="green"
        ></v-progress-circular>
        <span style="font-weight:bold">Listening telemetry</span>
        <v-btn icon dark v-on:click="stopRealtimeTelemetry">
          <v-icon>pause</v-icon>
        </v-btn>
      </v-snackbar>

      <inprogress
        :dialog="operationInProcess"
        :message="operationInProcessMessage"
      ></inprogress>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from "vuex";
import Chart from "@/components/Chart";
import ChartNew from "@/components/ChartNew";

export default {
  name: "Telemetry",

  components: {
    chart: Chart,
    "chart-new": ChartNew,
  },

  data: function() {
    return {
      drawer: true,
      timeOffset: 0,
      validForm: false,
      selectedMesaureAvailableRules: [
        (v) => !!v || "Telemetry measure required",
      ],
      selectedTimeRules: [(v) => !!v || "Time constrain required"],
      windowTimeRules: [(v) => !!v || "Window time required"],
      selectedDeviceRules: [
        (v) => !!v || "Select at least one device",
        (v) => v.length > 0 || "Select at least one device",
      ],

      telemetryChartModel: {},
      eventsListModel: [],

      selectedDevices: [],
      selectedMeasure: null,
      measuresAvailable: [
        {
          id: "tem",
          label: "Temperature (°C)",
          unit: {
            value: 1,
            label: "°C",
          },
          scalar: true,
          default: true,
        },
        {
          id: "pre",
          label: "Pressure (hPa)",
          unit: {
            value: 1,
            label: "hPa",
          },
          scalar: true,
          default: true,
        },
        {
          id: "hum",
          label: "Humidity (%)",
          unit: {
            value: 1,
            label: "o/o",
          },
          scalar: true,
          default: true,
        },
        {
          id: "acc",
          label: "Accelerometer (mg)",
          unit: {
            value: 0.001,
            label: "g",
          },
          scalar: false,
          dimensions: ["x", "y", "z"],
          default: true,
        },
        {
          id: "gyr",
          label: "Gyroscope (mdps)",
          unit: {
            value: 0.001,
            label: "dps",
          },
          scalar: false,
          dimensions: ["x", "y", "z"],
          default: true,
        },
        {
          id: "mag",
          label: "Magnetometer (mgauss)",
          unit: {
            value: 0.001,
            label: "gauss",
          },
          scalar: false,
          dimensions: ["x", "y", "z"],
          default: true,
        },
      ],
      timestamps: [],
      openDataPicker: false,
      selectedWindowTime: null,
      selectedTime: {},
      timeHourStart: "00:00",
      timeHourEnd: "23:59",
      selectedComplexTime: [],
      selectedEndTime: {
        timeObj: null,
        time: "",
        timeHour: "23:59",
      },
      selectedStartTime: {
        timeObj: null,
        time: "",
        timeHour: "00:00",
      },
      windowTimes: [
        {
          id: 0,
          label: "Realtime",
        },
        {
          id: 1,
          label: "Last 1h",
        },
        {
          id: 3,
          label: "3h",
        },
        {
          id: 6,
          label: "6h",
        },
        {
          id: -1,
          label: "Custom",
        },
      ],

      units: [
        {
          value: 1000,
          label: "x 1000 (kilo)",
        },
        {
          value: 100,
          label: "x 100 (hecto)",
        },
        {
          value: 10,
          label: "x 10 (deca)",
        },
        {
          value: 1,
          label: "x 1",
        },
        {
          value: 0.1,
          label: "x 0,01 (deci)",
        },
        {
          value: 0.01,
          label: "x 0,01 (centi)",
        },
        {
          value: 0.001,
          label: "x 0,001 (milli)",
        },
        {
          value: 0.000001,
          label: "x 0,000001 (micro)",
        },
      ],
      selectedUnit: null,
    };
  },

  computed: {
    ...mapState({
      devices: (state) => state.devices.devices,
      telemetry: (state) => state.telemetry.telemetry,
      events: (state) => state.telemetry.events,
      telemetryRealtime: (state) => state.telemetry.listeningRelatime,
      currentMeasuresAvailable: (state) => state.telemetry.measuresAvailable,
      operationInProcess: "operationInProcess",
      operationInProcessMessage: "operationInProcessMessage",
    }),
    minSelectedTimestamp() {
      if (this.timestamps.length == 0) return new Date(0);
      return Math.min(...this.timestamps.map((d) => d.getTime()));
    },
    maxSelectedTimestamp() {
      if (this.timestamps.length == 0) return new Date(0);
      return Math.max(...this.timestamps.map((d) => d.getTime()));
    },
  },

  watch: {
    selectedWindowTime() {
      this.buildWindowTime();
    },
    "selectedTime.time": function() {
      if (this.selectedTime.time && this.selectedTime.time != "") {
        this.selectedTime.timeObj = new Date(
          Date.parse(this.selectedTime.time) +
            this.timeOffset +
            new Date().getTimezoneOffset() * 60 * 1000
        );
      }
    },

    timeHourStart: function() {
      let ch = this.timeHourStart.split(":");
      let hh = parseInt(ch[0]);
      let mm = parseInt(ch[1]);
      let offset = hh * 60 * 60 * 1000 + mm * 60 * 1000;
      this.selectedStartTime.timeObj = new Date(
        Date.parse(this.selectedStartTime.time) +
          offset +
          new Date().getTimezoneOffset() * 60 * 1000
      );
    },
    timeHourEnd: function() {
      let ch = this.timeHourEnd.split(":");
      let hh = parseInt(ch[0]);
      let mm = parseInt(ch[1]);
      let offset = hh * 60 * 60 * 1000 + mm * 60 * 1000;
      this.selectedEndTime.timeObj = new Date(
        Date.parse(this.selectedEndTime.time) +
          offset +
          new Date().getTimezoneOffset() * 60 * 1000
      );
    },

    selectedComplexTime: function() {
      if (this.selectedComplexTime.length > 2) {
        this.selectedComplexTime.shift();
      }

      let ch = this.timeHourStart.split(":");
      let hh = parseInt(ch[0]);
      let mm = parseInt(ch[1]);
      let startOffset = hh * 60 * 60 * 1000 + mm * 60 * 1000;
      ch = this.timeHourEnd.split(":");
      hh = parseInt(ch[0]);
      mm = parseInt(ch[1]);
      let endOffset = hh * 60 * 60 * 1000 + mm * 60 * 1000;

      this.selectedStartTime.time = this.selectedComplexTime[0];
      this.selectedStartTime.timeObj = new Date(
        Date.parse(this.selectedStartTime.time) +
          startOffset +
          new Date().getTimezoneOffset() * 60 * 1000
      );

      if (this.selectedComplexTime[1]) {
        this.selectedEndTime.time = this.selectedComplexTime[1];
        this.selectedEndTime.timeObj = new Date(
          Date.parse(this.selectedEndTime.time) +
            endOffset +
            new Date().getTimezoneOffset() * 60 * 1000
        );
      }

      if (this.selectedEndTime.timeObj && this.selectedStartTime.timeObj)
        if (
          this.selectedEndTime.timeObj.getTime() <
          this.selectedStartTime.timeObj.getTime()
        ) {
          let temp = this.selectedEndTime;
          this.selectedEndTime = this.selectedStartTime;
          this.selectedStartTime = temp;
        }
    },

    telemetry: {
      handler() {
        if (this.selectedMeasure) this.buildTelemetryData();
      },
      deep: true,
    },

    events: {
      handler() {
        this.buildEventsData();
      },
      deep: true,
    },

    selectedDevices: function() {
      if (this.selectedMeasure) this.buildTelemetryData();
      this.buildEventsData();
    },

    selectedMeasure: function() {
      if (this.selectedMeasure) {
        this.selectedUnit = this.selectedMeasure.unit.value;
        this.buildTelemetryData();
      }
    },
    selectedUnit: function() {
      if (this.selectedUnit) {
        this.buildTelemetryData();
      }
    },
  },

  async destroyed() {
    await this.$store.dispatch("telemetry/stopTelemetryRealtime");
  },

  methods: {
    submit: async function() {
      this.openDataPicker = false;
      this.validForm = this.$refs.form.validate();
      if (this.validForm) {
        if (this.telemetryRealtime)
          await this.$store.dispatch("telemetry/stopTelemetryRealtime");

        this.buildWindowTime();
        await this.$store.dispatch(
          this.selectedWindowTime.id == 0
            ? "telemetry/startTelemetryReltime"
            : "telemetry/fetchTelemetry",
          {
            devices: this.selectedDevices,
            startTime: this.selectedStartTime.timeObj,
            endTime: this.selectedEndTime.timeObj,
          }
        );
        await this.$store.dispatch(
          this.selectedWindowTime.id == 0
            ? "telemetry/startTelemetryReltime"
            : "telemetry/fetchEvents",
          {
            devices: this.selectedDevices,
            startTime: this.selectedStartTime.timeObj,
            endTime: this.selectedEndTime.timeObj,
          }
        );
        this.openDataPicker = false;
        return;
      }
    },

    stopRealtimeTelemetry: async function() {
      await this.$store.dispatch("telemetry/stopTelemetryRealtime");
    },

    buildTelemetryData: function() {
      let measureId = this.selectedMeasure.id; //.toLowerCase()
      let datasetMapVersion = [];

      this.telemetry.forEach((deviceTelemetry) => {
        let filter = this.selectedDevices.filter(
          (device) => device.id == deviceTelemetry.id
        );
        if (filter.length <= 0) return;

        let device = filter[0];
        let originalLabel = device.label + "";
        let measureUnit = this.currentMeasuresAvailable.find(
          (ma) => ma.id.toLowerCase() === measureId.toLowerCase()
        ); //device.configurationSignaled.measures.find(m=>m.id.toLowerCase()==measureId.toLowerCase()).unit.value
        deviceTelemetry.data.forEach((sample) => {
          let label = originalLabel + "";
          if (sample.metadata)
            if (sample.metadata.tech)
              label += "(" + sample.metadata.tech.toUpperCase() + ")";
          if (typeof sample[measureId] === "object") {
            for (let dim in sample[measureId]) {
              let compositeLabel = label + " - " + dim;
              if (!datasetMapVersion[compositeLabel])
                datasetMapVersion[compositeLabel] = {
                  name: compositeLabel,
                  data: [],
                };
              datasetMapVersion[compositeLabel].data.push({
                x: new Date(sample.timestamp),
                y: sample[measureId][dim],
                unit: measureUnit,
              });
            }
          } else if (sample[measureId] !== undefined) {
            if (!datasetMapVersion[label])
              datasetMapVersion[label] = {
                name: label,
                data: [],
              };
            datasetMapVersion[label].data.push([
              new Date(sample.timestamp),
              sample[measureId],
            ]);
          }
        });
      });

      this.telemetryChartModel = {
        datasets: [],
      };
      for (let label in datasetMapVersion) {
        datasetMapVersion[label].data.sort((d1, d2) => {
          return (d1[0] || d1.x).getTime() <= (d2[0] || d2.x).getTime()
            ? -1
            : 1;
        });
        this.telemetryChartModel.datasets.push(datasetMapVersion[label]);
      }
    },

    buildEventsData() {
      this.eventsListModel = []
        .concat(
          ...this.events
            .filter((deviceEvents) =>
              this.selectedDevices.find((d) => d.id === deviceEvents.id)
            )
            .map((deviceEvents) => {
              const device = this.devices.find((d) => d.id === deviceEvents.id);
              return deviceEvents.data.map((e) => {
                const eCpy = {};
                Object.assign(eCpy, e);
                eCpy.device_id = deviceEvents.id;
                // e.label = device.attributes.customName? device.attributes.customName : deviceEvents.id;
                eCpy.label = device.label;
                // e.deviceImg = device.attributes.technologyImage;
                eCpy.color = eCpy.message.split("----")[1];
                eCpy.message = eCpy.message.split("----")[0];
                return eCpy;
              });
            })
        )
        .reverse();
    },

    buildWindowTime() {
      let hours = this.selectedWindowTime.id;
      switch (hours) {
        case 0:
          this.selectedStartTime.timeObj = new Date();
          this.selectedEndTime.timeObj = new Date();
          break;
        case -1:
          this.selectedTime = this.selectedStartTime;
          this.timeOffset = 0;
          this.openDataPicker = true;
          break;
        case null:
          break;
        case undefined:
          break;
        default:
          this.selectedEndTime.timeObj = new Date();
          this.selectedStartTime.timeObj = new Date(
            this.selectedEndTime.timeObj.getTime() - hours * 60 * 60 * 1000
          );
          return;
      }
    },
  },
};
</script>
